import { useEffect, useRef, useState } from "react";

const BASE = process.env.REACT_APP_BASE_URL;

// Renders a backend-served, auth-protected media URL (e.g. "/api/v1/uploads/media/:mediaPid")
// as a blob object URL usable in <img src>. Passes data:/blob:/absolute URLs through unchanged
// (e.g. a freshly-picked file previewed before save, or an already-resolved blob URL).
export const useAuthedImage = (url) => {
  const [src, setSrc] = useState("");
  const objectUrlRef = useRef(null);

  useEffect(() => {
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }

    if (!url) {
      setSrc("");
      return;
    }

    if (url.startsWith("data:") || url.startsWith("blob:") || /^https?:\/\//i.test(url)) {
      setSrc(url);
      return;
    }

    let cancelled = false;
    fetch(`${BASE}${url}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load image");
        return res.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        const objectUrl = URL.createObjectURL(blob);
        objectUrlRef.current = objectUrl;
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setSrc("");
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  useEffect(
    () => () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
    },
    []
  );

  return src;
};
